import { Box, IconButton, Tooltip } from '@mui/material';
import bagActiveIcon from '../../assets/logos/bag-active.svg';
import bagInactiveIcon from '../../assets/logos/bag-inactive.svg';
import analyticsActiveIcon from '../../assets/logos/analytics-active.svg';
import analyticsInactiveIcon from '../../assets/logos/analytics-inactive.svg';
import gearActiveIcon from '../../assets/logos/gear-active.svg';
import gearInactiveIcon from '../../assets/logos/gear-inactive.svg';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isCheckoutActive = location.pathname === '/' || location.pathname === '/checkout';
  const isAnalyticsActive = location.pathname === '/analytics';
  const isOrderConfirmationActive = location.pathname === '/order-confirmation';

  return (
    <Box
      sx={{
        width: { xs: '100%', md: 60 },
        height: { xs: 'auto', md: '100%' },
        backgroundColor: '#fff',
        order: { xs: 2, md: 0 },
        flexShrink: 0,
        borderTop: { xs: '1px solid #e0e0e0', md: 'none' },
        borderRight: { md: '1px solid #e0e0e0' },
        display: 'flex',
        flexDirection: { xs: 'row', md: 'column' },
        alignItems: 'center',
        justifyContent: 'flex-start',
        py: { xs: 1, md: 2 },
        gap: 2,
      }}
    >
      <Tooltip title="Checkout Page" placement="right">
        <IconButton onClick={() => navigate('/checkout')} >
          <img src={isCheckoutActive ? bagActiveIcon : bagInactiveIcon } alt="Bag Icon" style={{ width: 35, height: 35 }} />
        </IconButton>
      </Tooltip>
      
      <Tooltip title="Business Information" placement="right">
        <IconButton onClick={() => navigate('/order-confirmation')}>
          <img src={isOrderConfirmationActive ? gearActiveIcon : gearInactiveIcon } alt="Gear Icon" style={{ width: 35, height: 35 }} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Analytics" placement="right">
        <IconButton onClick={() => navigate('/analytics')}>
          <img src={isAnalyticsActive ? analyticsActiveIcon : analyticsInactiveIcon} alt="Analytics Icon" style={{ width: 35, height: 35 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default Sidebar;
